import React from 'react'

const ShippingButton = ({ isActive, label, onClick }) => {
  const baseClasses = "btn";
  let buttonClasses;

  switch (label) {
      case "Free":
          buttonClasses = isActive ? "btn-green" : "btn-gray";
          break;
      case "ไม่รู้":
          buttonClasses = isActive ? "btn-yellow" : "btn-gray";
          break;
      case "COD":
          buttonClasses = isActive ? "btn-red" : "btn-gray";
          break;
      default:
          buttonClasses = "btn-gray";
  }
  return (
    <button className={`${baseClasses} ${buttonClasses}`} onClick={onClick}>
        {label}
    </button>
  );
}

export default ShippingButton

